import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Paper,
  Snackbar,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import backgroundImg from "../../../assets/ImgFundo/fundo-abstratoC.jpg";

const ListagemEdicoesDocumentos = () => {
  const apiUrl = process.env.REACT_APP_API_URL || "/api";
  const navigate = useNavigate();

  const [documentos, setDocumentos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [alertMessage, setAlertMessage] = useState({ type: "", text: "" });

  const fetchDocumentos = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}/documentos`);
      setDocumentos(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Erro ao carregar documentos:", error);
      setAlertMessage({ type: "error", text: "Erro ao carregar documentos." });
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDocumentos();
  }, []);

  const handleDelete = async (id) => {
    const token = localStorage.getItem("token");
    if (!token) {
      setAlertMessage({
        type: "error",
        text: "Você precisa estar autenticado para excluir documento.",
      });
      setOpenSnackbar(true);
      return;
    }

    try {
      await axios.delete(`${apiUrl}/documentos/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAlertMessage({ type: "success", text: "Documento excluído com sucesso!" });
      setOpenSnackbar(true);
      fetchDocumentos();
    } catch (error) {
      console.error("Erro ao excluir documento:", error);
      setAlertMessage({ type: "error", text: "Erro ao excluir documento." });
      setOpenSnackbar(true);
    }
  };

  return (
    <div
      style={{
        padding: "20px",
        backgroundImage: `url(${backgroundImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
      }}
    >
      <Box sx={{ p: 3 }}>
        <hr style={{ margin: "40px 0", borderTop: "1px solid #ddd" }} />
        <hr style={{ margin: "40px 0", borderTop: "1px solid #ddd" }} />

        <Typography
          variant="h2"
          align="center"
          gutterBottom
          style={{
            fontFamily: "'Lato', serif",
            color: "#800020",
            textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
            borderBottom: "4px solid #d4af37",
            paddingBottom: "10px",
            textTransform: "uppercase",
            marginTop: "7%",
          }}
        >
          Lista de Documentos Avulsos
        </Typography>

        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <CircularProgress />
          </Box>
        ) : (
          <List sx={{ backgroundColor: "#f4f6f8", borderRadius: 2, boxShadow: 1 }}>
            {documentos.map((documento) => (
              <Paper
                key={documento._id}
                sx={{ marginBottom: 2, padding: 2, borderRadius: 1, boxShadow: 1 }}
              >
                <ListItem
                  secondaryAction={
                    <>
                      <IconButton
                        edge="end"
                        aria-label="edit"
                        onClick={() =>
                          navigate(`/PainelDeControle/Editores/EditorDocumentos/${documento._id}`)
                        }
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        edge="end"
                        aria-label="delete"
                        onClick={() => handleDelete(documento._id)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </>
                  }
                >
                  <ListItemText
                    primary={<Typography variant="h6">{documento.titulo}</Typography>}
                    secondary={
                      <Typography variant="body2" color="textSecondary">
                        {documento.autor || "Autor não informado"}
                      </Typography>
                    }
                  />
                </ListItem>
                <Divider />
              </Paper>
            ))}
          </List>
        )}

        <Box sx={{ display: "flex", justifyContent: "flex-end", marginTop: 3 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate("/PainelDeControle/DashBoardDocumentos")}
            sx={{ padding: "10px 20px", fontSize: "16px" }}
          >
            Adicionar Novo Documento
          </Button>
        </Box>
      </Box>

      <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={() => setOpenSnackbar(false)}>
        <Alert severity={alertMessage.type}>{alertMessage.text}</Alert>
      </Snackbar>
    </div>
  );
};

export default ListagemEdicoesDocumentos;
